/** Cockpit — executive overview + drill-down sub-pages. */

export const COCKPIT_FLOWS = [
  { id: "overview", label: "Overview" },
  { id: "journey", label: "Before → Decision → After" },
  { id: "reasoning", label: "Why this 7R" },
  { id: "evidence", label: "Decision evidence" },
  { id: "assessments", label: "7C / 7S" },
  { id: "timeline", label: "Gates & value" },
];

export const COCKPIT_DRILL = COCKPIT_FLOWS.filter((f) => f.id !== "overview");

export const COCKPIT_FOCUS_DETAIL = {
  overview: "Recommendation, coverage and next human action.",
  journey: "Before pain, 7R decision and forecast/proven after state.",
  reasoning: "Supporting evidence, constraints and alternative ranking.",
  evidence: "Input domains and authorization eligibility.",
  assessments: "7C and 7S lenses fed by assessment inputs.",
  timeline: "G1–G8 track and expected vs actual value.",
};
